"use strict";

import { form } from "../../models/form";
import Analytics from "helpers/analytics/analytics";
import { AnalyticsEventType } from "helpers/analytics/AnalyticsEventType";

import Server from "helpers/server";
import { Model } from "../../components/never-knowingly-undersold-claim/NeverKnowinglyUndersoldClaimModel";
import "../../components/inputs/date-picker";
import Logger from "../../components/never-knowingly-undersold-claim/Logger";
import BoughtInShopErrorMessage from "../../components/never-knowingly-undersold-claim/components/BoughtInShopErrorMessage";
import PurchaseDateAndOrder from "../../components/never-knowingly-undersold-claim/components/PurchaseDateAndOrder";
import WhereDidYouPurchaseQuestion from "../../components/never-knowingly-undersold-claim/components/WhereDidYouPurchaseQuestion";
import WhereLowerPriceQuestion from "../../components/never-knowingly-undersold-claim/components/WhereLowerPriceQuestion";

import PurchaseDetailsAndCustomerDetails from "../../components/never-knowingly-undersold-claim/components/PurchaseDetailsAndCustomerDetails";

import SubmitButton from "../../components/never-knowingly-undersold-claim/components/SubmitButton";
import ValidatableFormField from "../inputs/ValidatableFormField";
import ValidatableNeverKnowinglyUndersoldDateField from "./ValidatableNeverKnowinglyUndersoldDateField";
import { email } from "helpers/email-validation";
import {
  sendSplunkAnalytics,
  sendSplunkAnalyticsForModelChanges,
} from "./NeverKnowinglyUndersoldSplunkAnalytics";
import FormUtils from "../formUtils";

export default class NeverKnowinglyUndersoldForm {
  constructor(rootFormElem) {
    this.formElement = rootFormElem;
    this.model = new Model(rootFormElem);
    this.logger = new Logger("NeverKnowinglyUndersoldForm");
    this.inputTimeout = null;
    this.NUM_DAYS_ALLOWED_TO_CLAIM = 36;
  }

  static hideSubmitErrorMessage() {
    const messageArea = document.querySelector("#error-submitting-message");
    messageArea.classList.add("u-hidden");
    messageArea.setAttribute("aria-hidden", "true");
  }

  static showSubmitErrorMessage() {
    const messageArea = document.querySelector("#error-submitting-message");
    messageArea.classList.remove("u-hidden");
    messageArea.setAttribute("aria-hidden", "false");
    messageArea.setAttribute("role", "alert");
    messageArea.scrollIntoView();
  }

  static hideValidationErrorMessages() {
    const messageArea = document.querySelector("#feedback-messages");
    messageArea.classList.add("u-hidden");
    messageArea.setAttribute("aria-hidden", "true");
  }

  static onSubmissionError(error) {
    `${error}`;
    NeverKnowinglyUndersoldForm.hideSubmitErrorMessage();

    const formElem = document.getElementById(
      "never-knowingly-undersold-claim-form"
    );
    const button = formElem.querySelector("button");

    button.disabled = false;
    button.classList.remove("button--loading");
    button.classList.remove("u-button-loader");

    NeverKnowinglyUndersoldForm.showSubmitErrorMessage();
  }

  static onFormSubmit(e) {
    if (NeverKnowinglyUndersoldForm.isRestOfFormHidden()) {
      e.preventDefault();
      NeverKnowinglyUndersoldForm.hideValidationErrorMessages();
    } else {
      `${e}`;
      NeverKnowinglyUndersoldForm.hideSubmitErrorMessage();
      NeverKnowinglyUndersoldForm.hideValidationErrorMessages();
      sendSplunkAnalytics();
    }
  }

  static publishFormValidationErrorAnalytics(invalidItems) {
    Analytics.resetErrors();
    invalidItems.forEach((invalidItem) => {
      const errorMsgExists = invalidItem.validationElement.hasAttribute(
        "data-incomplete-message"
      );
      if (errorMsgExists) {
        const error = invalidItem.validationElement.getAttribute(
          "data-incomplete-message"
        );
        Analytics.addError(error);
      }
    });
    Analytics.publish(AnalyticsEventType.ANALYTICS_DATA_UPDATE);
  }

  static onFormValidationFailed(e, invalidItems = []) {
    e.preventDefault();

    const messageArea = document.querySelector("#feedback-messages");
    if (messageArea) {
      messageArea.classList.remove("u-hidden");
      messageArea.setAttribute("aria-hidden", "false");
      messageArea.setAttribute("role", "alert");
      const messageHeading = messageArea.querySelector(
        ".error-message-heading"
      );
      messageHeading.innerHTML = FormUtils.formatErrorMessageHeading(
        invalidItems.length
      );

      const messageTextArea = messageArea.querySelector(
        ".error-message-text-container"
      );
      const existingMessagesDiv = messageTextArea.querySelector(
        ".error-message-body"
      );
      messageTextArea.removeChild(existingMessagesDiv);

      const newMessagesDiv = document.createElement("div");
      newMessagesDiv.classList.add("error-message-body");
      messageTextArea.appendChild(newMessagesDiv);

      invalidItems.forEach((invalidItem) => {
        const message = invalidItem.validationElement.hasAttribute(
          "data-incomplete-message"
        )
          ? invalidItem.validationElement.getAttribute(
              "data-incomplete-message"
            )
          : "A form field is incomplete";
        let p = document.createElement("p");
        p.classList.add("validation-error--bullet-item");
        p.innerHTML = `<a href="#${invalidItem.focusTarget.id}">${message}</a>`;
        newMessagesDiv.appendChild(p);
      });

      let accordions = document.querySelectorAll("[data-accordion]");
      if (accordions) {
        for (let i = 0; i < accordions.length; i++) {
          var section = accordions[i];
          if (section.querySelectorAll(".input--invalid").length > 0) {
            let content = section.querySelector(".nku-accordion__content");
            let button = section.querySelector("h2 button");
            if (!content.getAttribute("style") == "") {
              button.click();
            }
          }
        }
      }
    }

    NeverKnowinglyUndersoldForm.publishFormValidationErrorAnalytics(
      invalidItems
    );

    if (invalidItems.length > 0) invalidItems[0].focusTarget.focus();
  }

  addRetailerNameListener(model) {
    let _this = this;
    this.inputTimeout = null;
    let _logger = this.logger;
    let input = this.formElement.querySelector(
      "#retailer-website-details--name"
    );
    if (input) {
      input.addEventListener("keyup", () => {
        if (_this.inputTimeout) window.clearTimeout(_this.inputTimeout);
        _this.inputTimeout = window.setTimeout(
          () => callRetailerService(input),
          500
        );
      });
    }

    function callRetailerService(input) {
      let retailerName = input.value.trim();
      if (retailerName.length) {
        let url = `/nku/is-retailer-allowed?retailer=${encodeURIComponent(
          retailerName
        )}`;
        _logger.debug(`Calling ${url}`);
        Server.getJson(url, { method: "GET", credentials: "same-origin" })
          .then((response) => {
            _logger.debug(
              `Succesful response with body ${JSON.stringify(response)}`
            );
            model.updateAllowedRetailerValue(response.allowed);
            if (!response.allowed) _this.sendNotAllowedRetailerAnalyticsError();
          })
          .catch(() => {
            _logger.debug("ERROR/TIMEOUT");
            model.updateAllowedRetailerValue(true);
          });
      } else {
        _this.formElement.dispatchEvent(new Event("change"));
      }
    }
  }

  updateRetailerNameFormAfterBackButton() {
    let input = this.formElement.querySelector(
      "#retailer-website-details--name"
    );
    if (input.value.trim().length) {
      input.dispatchEvent(new Event("keyup"));
    }
  }

  addResetRetailerListener() {
    let _this = this;
    let input = this.formElement.querySelector(
      "#retailer-website-details--name"
    );
    document
      .querySelector("#clearRetailerButton")
      .addEventListener("click", (e) => {
        e.preventDefault();
        input.value = "";
        _this.formElement.dispatchEvent(new Event("change"));
      });
  }

  setupInputFieldsForValidation() {
    let f = (id, additionalValidations) => {
      /*
        jsdom does not correctly set pattern property
       */
      const element = document.querySelector(id);
      const options = { useLogger: true };
      if (
        typeof element.pattern === "undefined" &&
        element.getAttribute("pattern") !== null
      ) {
        element.pattern = element.getAttribute("pattern");
      }
      return ValidatableFormField(
        this.formElement.querySelector(id),
        additionalValidations,
        options
      );
    };
    let date = (id) =>
      ValidatableNeverKnowinglyUndersoldDateField(
        this.formElement.querySelector(id),
        this.NUM_DAYS_ALLOWED_TO_CLAIM
      );

    const emailValidation = email.validate;

    return [
      date("#product-details--purchase-date"),
      f("#product-details--order-number"),
      f("#product-details--jl-product-code"),
      f("#product-details--name"),
      f("#product-details--jl-price"),
      f("#new-johnlewis-price"),
      f("#your-details--title"),
      f("#your-details--first-name"),
      f("#your-details--last-name"),
      f("#your-details--telephone"),
      f("#your-details--email", emailValidation),
      f("#your-details--postcode"),
    ];
  }

  sendNotAllowedRetailerAnalyticsError() {
    this.logger.debug("Sending analytics error for not allowed retailer");
    Analytics.addAndPublish(
      `Sorry - we can't match this retailer as it's an online-only business.`,
      AnalyticsEventType.DATA_VALIDATION_ERROR
    );
    document.body.dispatchEvent(new CustomEvent("analyticsDataUpdate"));
  }

  static isRestOfFormHidden() {
    return document
      .getElementById("rest-of-form")
      .classList.contains("u-hidden");
  }

  init() {
    this.formElement.setAttribute("novalidate", "novalidate");
    this.model.init();
    const components = [
      new WhereDidYouPurchaseQuestion(this.model.resetWherePurchasedQuestion),
      new WhereLowerPriceQuestion(),
      new BoughtInShopErrorMessage(),
      new PurchaseDateAndOrder(),
      new PurchaseDetailsAndCustomerDetails(),
      new SubmitButton(this.formElement.querySelector("button")),
    ];

    this.model.addListener((state) =>
      components.forEach((component) => component.render(state))
    );

    this.model.addListener(sendSplunkAnalyticsForModelChanges);

    form.create(
      this.formElement,
      this.setupInputFieldsForValidation(),
      NeverKnowinglyUndersoldForm.onFormSubmit,
      NeverKnowinglyUndersoldForm.onFormValidationFailed
    );

    this.model.resetPurchaseQuestions();
  }
}
